module.exports = __webpack_public_path__ + "video-thumbnail-vote-d41b83416815613422e2ca741bf692cc.jpg";